module.exports = __webpack_public_path__ + "9942a2cf91d7029f6437e451e21362d0.webp";